module.exports = __webpack_public_path__ + "static/media/instagram.d96aca07.svg";